module.exports = __webpack_public_path__ + "img/0.0cbdf51f.png";